import type { PlanModality } from "@/services/types"
import { cn } from "@/shared/lib/cn"

export interface ModalityTabsProps {
  value: PlanModality
  onChange: (modality: PlanModality) => void
  className?: string
}

/**
 * Alternador entre as duas modalidades de plano.
 *
 * `role="tablist"` com `aria-selected` de verdade: no prototipo eram dois
 * botoes soltos, e um leitor de tela nao tinha como saber qual deles estava
 * ativo nem que os dois faziam parte do mesmo grupo.
 */
export function ModalityTabs({ value, onChange, className }: ModalityTabsProps) {
  const tabClass = (active: boolean) =>
    cn(
      "px-5 py-2.5 rounded-xl text-sm font-semibold transition-all cursor-pointer",
      active ? "bg-verde-profundo text-white shadow-md" : "text-verde-profundo/55 hover:text-verde-profundo",
    )

  return (
    <div
      role="tablist"
      aria-label="Modalidade de plano"
      className={cn("flex gap-1 p-1 bg-verde-profundo/8 rounded-2xl w-fit", className)}
    >
      <button
        type="button"
        role="tab"
        aria-selected={value === "flex"}
        onClick={() => onChange("flex")}
        className={cn(tabClass(value === "flex"), "flex items-center gap-1.5")}
      >
        Flex
        <span
          className={cn("text-[10px] font-medium", value === "flex" ? "text-dourado-claro" : "text-dourado-escuro")}
        >
          com copart.
        </span>
      </button>

      <button
        type="button"
        role="tab"
        aria-selected={value === "cobertura-total"}
        onClick={() => onChange("cobertura-total")}
        className={tabClass(value === "cobertura-total")}
      >
        Cobertura Total
      </button>
    </div>
  )
}
